import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ColorPicker = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='m10 7 7 7M4.293 15.707 15.586 4.414a2 2 0 0 1 2.828 0l1.172 1.172a2 2 0 0 1 0 2.828L8.293 19.707a1 1 0 0 1-.707.293H5a1 1 0 0 1-1-1v-2.586a1 1 0 0 1 .293-.707'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.879 3.707 11.5 7.086l-.793-.793a1 1 0 1 0-1.414 1.414l.793.793-6.5 6.5A2 2 0 0 0 3 16.414V19a2 2 0 0 0 2 2h2.586A2 2 0 0 0 9 20.414l6.5-6.5.793.793a1 1 0 0 0 1.414-1.414l-.793-.793 3.379-3.379q.219-.22.384-.47a3 3 0 0 0-.384-3.773L19.12 3.707a3 3 0 0 0-4.242 0M11.5 9.914l2.586 2.586-2.5 2.5H6.414z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
